import React from 'react';
import { Calculator, Info, DollarSign, Clock, Percent, AlertCircle } from 'lucide-react';

const CostTable = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden">
      {/* Header */}
      <div className="p-6 bg-gradient-to-r from-slate-800 to-slate-900 text-white">
        <div className="flex items-center gap-3 mb-3">
          <Calculator className="h-6 w-6 text-[#F7BA45]" />
          <h2 className="text-xl font-bold">İhtiyaç Kredisi Maliyet Tablosu ve Örnek Hesaplama</h2>
        </div>
        <p className="text-slate-300 text-sm">
          Kredi maliyetlerini şeffaf bir şekilde görüntüleyin ve örnek hesaplama ile fikir edinin
        </p>
      </div>

      {/* Cost Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50">
              <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <DollarSign className="h-4 w-4 text-[#F7BA45]" />
                  Min. Tutar
                </div>
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <DollarSign className="h-4 w-4 text-[#F7BA45]" />
                  Max. Tutar
                </div>
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-[#F7BA45]" />
                  Vade Süresi
                </div>
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <Percent className="h-4 w-4 text-[#F7BA45]" />
                  Min. Yıllık Maaliyet Oranı
                </div>
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <Percent className="h-4 w-4 text-[#F7BA45]" />
                  Max. Yıllık Maaliyet Oranı
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            <tr className="hover:bg-slate-50 transition-colors">
              <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">500,00 TL</td>
              <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">500.000,00 TL</td>
              <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">3 - 36 Ay</td>
              <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">%25,89</td>
              <td className="px-6 py-4 text-sm text-slate-600 whitespace-nowrap">%81,51</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Example Calculation */}
      <div className="p-6 bg-[#F7BA45]/5 border-t border-slate-200">
        <div className="flex items-start gap-2">
          <Info className="h-5 w-5 text-[#F7BA45] flex-shrink-0 mt-0.5" />
          <div className="space-y-2">
            <h3 className="font-semibold text-slate-900">Örnek Hesaplama:</h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              36 ay vadeli 50.000 TL ihtiyaç kredisi çekmek istediğinizde, mevcut aylık en düşük faiz oranı olan 1,79 ile, 
              aylık taksit ödemesi <span className="font-semibold text-slate-700">4.771 TL</span>, banka tahsis ücreti 
              <span className="font-semibold text-slate-700"> 260 TL</span>, yıllık maliyet oranı ise 
              <span className="font-semibold text-slate-700"> %30,35</span> olacaktır. 36 ayın sonunda ödeyeceğiniz toplam ödeme tutarı ise 
              <span className="font-semibold text-slate-700"> 57.513 TL</span> olacaktır.
            </p>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-4 flex items-start gap-2 text-xs text-slate-500">
          <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
          <p>
            Bu hesaplama örnek niteliğinde olup, kredi tutarı, vade ve faiz oranlarına göre değişiklik gösterebilir. 
            Kesin kredi koşulları için lütfen banka şubelerine başvurunuz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CostTable;